import { Col, Form, message, Modal, Row, Spin, Table } from "antd";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import COLORS from "common/Colors";
import { reduce, uniqBy } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { connect, useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getLocations,
  getMenuList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import styled from "styled-components";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { ExclamationCircleFilled, EyeOutlined } from "@ant-design/icons";
import AddRole from "./AddRole";
import RoleDetails from "./RoleDetails";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import EditRole from "./EditRole";
import RolesAndPermissions from "./RolesAndPermissions";
import EditPermission from "./EditPermission";
import { bindActionCreators } from "redux";
import { setMenuList, setRoleList, setUserList } from "redux/actions";

const RolesWrap = styled.div`
  .header-view {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const StyledTable = styled(Table)`
  table {
    table-layout: auto !important;
  }
  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-cell {
    padding: 10px;
    height: 50px !important;
    border: none;
  }

  .ant-table-thead
    > tr
    > th:not(:last-child):not(.ant-table-selection-column):not(
      .ant-table-row-expand-icon-cell
    ):not([colspan])::before {
    background: none;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #f0f0f0 !important;
  }
  .non-white {
    background: #f9f9f9;
  }
  .action-content {
    display: none;
  }

  .action-icons {
    display: none;
  }

  /* Show only when row is hovered */
  .ant-table-tbody > tr:hover .action-icons {
    display: inline-flex;
    gap: 8px;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-body {
    height: 60vh;
    overflow-y: scroll;
    padding: 24px;
    font-size: 14px;
    line-height: 1.5715;
    word-wrap: break-word;
  }
`;

//sample data
// const sampledata = [
//   {
//     roleId: "1",
//     roleName: "Admin",
//     department: ["HR", "Finance", "IT"],
//     locationId: ["1", "2"],
//   },
//   {
//     roleId: "2",
//     roleName: "Manager",
//     department: ["Sales", "Marketing"],
//     locationId: ["3"],
//   },
//   {
//     roleId: "3",
//     roleName: "Employee",
//     department: ["Support"],
//     locationId: ["2", "4"],
//   },
// ];

const RoleManagement = ({ saveRoleList, updateUserList, saveMenuList }) => {
  //redux selectors
  const userInfo = useSelector(getUserInfo);
  const clientId = useSelector(getClientid);
  const AllDepartmentList = useSelector(getAllDepartmentList);
  const menuList = useSelector(getMenuList);
  const locationList = useSelector(getLocations);
  const userRoleId = useSelector(getUserRoleId);
  const userList = useSelector(getUserList);
  console.log("menuList-->", menuList);

  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const csvLinkEl = React.useRef(null);
  const [form] = Form.useForm();
  const containerRef = React.useRef(null);

  //states
  const [roleList, setRoleList] = useState([]);
  const [addRole, toggleAddRole] = useState(false);
  const [btnLoader, togglebtnLoader] = useState(false);
  const [roleCSVlist, setroleCSVlist] = useState([]);
  const [filterRoleList, setFilterRoleList] = useState([]);
  const [roleid, setRoleid] = useState("");
  const [details, setDetails] = useState({});
  const [isViewDetails, setIsViewDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isEditRole, setIsEditRole] = useState(false);
  const [isViewPermission, setIsViewPermission] = useState(false);
  const [isEditPermission, setIsEditPermission] = useState(false);
  const [deleteRole, setDeleteRole] = useState(false);

  const fetchMasterData = async (fetch_master_data) => {
    const { code, roleList, userList, menuList, userrole } = await CALL_API(
      `master-data/${clientId}`,
      "post",
      {
        fetch_master_data,
        // Role screens need each user's menulist (omitted at login for speed).
        include_user_menulist: true,
      }
    );
    if (code === STATUS_CODE.SUCCESS) {
      if (fetch_master_data) {
        if (userrole === "Owner") {
          saveMenuList(menuList);
        } else {
          saveMenuList(
            userList?.find((user) => user?.userid === userInfo?.userid)
              ?.menulist
          );
        }
        saveRoleList(roleList);
        updateUserList(userList);
      }
    }
  };

  const getRoleList = async () => {
    setLoading(true);
    const { code, response } = await CALL_API(
      `owner-roles/${clientId}`,
      "get",
      {}
    );
    if (code === STATUS_CODE.SUCCESS) {
      setRoleList(response.reverse());
      setLoading(false);
    }
  };

  const CSVHeaders = [
    { label: "Name", key: "roleName" },
    { label: "LocatNo. of Employess inion", key: "roleID" },
    { label: "Employees with Custom Permission", key: "roleID" },
  ];

  const prepareCSV = async () => {
    togglebtnLoader(true);
    if (roleList.length > 0) {
      setroleCSVlist(
        reduce(
          filterRoleList,
          function (result, list) {
            result.push({
              "Role name": list?.roleName,
              "No. of Employess in": userList?.filter(
                (val) =>
                  val?.roleid?.includes(list?.roleId) && val?.statusid === "1"
              )?.length,
              "Employees with Custom Permission": userList?.filter(
                (val) =>
                  val?.roleid?.includes(list?.roleId) &&
                  val?.permissiontype === "Custom" &&
                  val?.statusid === "1"
              )?.length,
            });
            return result;
          },
          []
        )
      );
      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error(`No data available to download.`);
    }
    togglebtnLoader(false);
  };

  const confirmdelete = async (record) => {
    setLoading(true);
    const { code, Message } = await CALL_API(
      `owner-roles/${clientId}/${record?.roleId}`,
      "delete",
      {}
    );
    if (code === STATUS_CODE.SUCCESS) {
      setDeleteRole(false);
      fetchMasterData(true);
      message.success("Role Deleted Successfully");

      getRoleList();
      setLoading(false);
    }
  };

  const handleDelete = async (record) => {
    if (
      userList?.filter((val) => val?.roleid?.includes(record?.roleId))
        ?.length === 0
    ) {
      Modal.confirm({
        title: "Are you sure you want to delete this role",

        okText: "Yes",
        cancelText: "No",
        okButtonProps: {
          loading: loading,
        },
        onOk: async () => {
          confirmdelete(record);
        },
      });
    } else {
      Modal.warning({
        title: null,
        icon: null,
        content: (
          <div style={{ textAlign: "center" }}>
            <ExclamationCircleFilled
              style={{
                fontSize: "40px",
                color: "#ff4d4f",
                marginBottom: "16px",
              }}
            />
            <div style={{ fontSize: "15px", color: "#333" }}>
              You cannot delete this role because employees are still assigned
              to it. Please reassign them to another role before proceeding.
            </div>
          </div>
        ),
        okText: "Got it",
        okButtonProps: {
          style: {
            borderRadius: "6px",
            fontWeight: 500,
            textAlign: "center",
          },
        },
        centered: true,
        maskClosable: true,
      });
    }
  };

  const handleEdit = (record) => {};

  const handleFormChange = () => {
    const values = form.getFieldsValue();

    // If both filters are empty, show the full list
    if (
      (!values?.department || values.department.length === 0) &&
      (!values?.location || values.location.length === 0)
    ) {
      setFilterRoleList(roleList);
      return;
    }
    console.log("roleList-->", roleList);

    const roleFilter = roleList.filter((item) => {
      const departmentMatch =
        !values.department?.length ||
        item.department?.some((deptId) => values?.department?.includes(deptId));

      const locationMatch =
        !values.location?.length ||
        item.locationId?.some((locId) => values?.location?.includes(locId));

      return departmentMatch && locationMatch;
    });

    setFilterRoleList(roleFilter);
  };

  const columns = [
    {
      title: "Role Name",
      dataIndex: "roleName",
      key: "role_name",
      width: "25%",
    },
    {
      title: "No. of Employees in",
      dataIndex: "roleId",
      key: "roleId",
      align: "center",
      width: "25%",
      render: (roleId) => {
        return userList?.filter(
          (val) => val?.roleid?.includes(roleId) && val?.statusid === "1"
        )?.length;
      },
    },
    {
      title: "Employees with Custom Permission",
      dataIndex: "roleId",
      key: "roleId",
      align: "center",
      width: "25%",
      render: (roleId) => {
        return userList?.filter(
          (val) =>
            val?.roleid?.includes(roleId) &&
            val?.statusid === "1" &&
            val?.permissiontype === "Custom"
        )?.length;
      },
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      width: "25%",
      render: (_, record) => (
        <>
          <div className="action-icons">
            <span
              style={{ marginRight: 8, cursor: "pointer", color: "#2D53DA" }}
              onClick={(e) => {
                e.stopPropagation();
                ViewRole(record, true);
                setIsViewPermission(true);
              }}
            >
              <EyeOutlined
                style={{
                  cursor: "pointer",
                  color: "#2D53DA",
                  fontSize: "18px",
                }}
              />{" "}
              Permission
            </span>
            {Menulist?.find(
              (item) =>
                item?.key === "manage" &&
                item?.subMenu.find(
                  (subItem) =>
                    subItem?.key === "roles" && subItem?.permission.edit
                )
            ) && (
              <Edit
                style={{ cursor: "pointer", marginRight: "10px" }}
                corlor="red"
                onClick={(e) => {
                  e.stopPropagation();
                  ViewRole(record, true);
                  setIsEditRole(true);
                }}
              />
            )}
            {Menulist?.find(
              (item) =>
                item?.key === "manage" &&
                item?.subMenu.find(
                  (subItem) =>
                    subItem?.key === "roles" && subItem?.permission?.delete
                )
            ) && (
              <Trash
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(record);
                }}
              />
            )}
          </div>
        </>
      ),
    },
  ];

  const ViewRole = (RoleObject, isViewOnly = false) => {
    setRoleid(RoleObject.roleId);

    setDetails({
      ...RoleObject,
      isViewOnly,
    });
  };

  useEffect(() => {
    getRoleList();
    handleFormChange();
  }, []);

  useEffect(() => {
    handleFormChange();
  }, [roleList]);

  return (
    <RolesWrap>
      {!addRole && !isViewDetails && !isEditRole && !isEditPermission && (
        <>
          <div className="header-view">
            <h5 className="">Role - Permission</h5>
            <div className="header-buttons">
              <ButtonOutlined
                disabled={filterRoleList === 0}
                onClick={prepareCSV}
              >
                Export CSV File
              </ButtonOutlined>
              <CSVLink
                header={CSVHeaders}
                data={roleCSVlist}
                filename={"role-list.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
              {Menulist?.find(
                (item) =>
                  item?.key === "manage" &&
                  item?.subMenu.find(
                    (subItem) =>
                      subItem?.key === "roles" && subItem?.permission.create
                  )
              ) && (
                <ButtonFilled
                  className="me-0"
                  type="primary"
                  onClick={() => toggleAddRole(true)}
                >
                  + Add Role
                </ButtonFilled>
              )}
            </div>
          </div>
          <Form
            form={form}
            layout="vertical"
            className="mt-2"
            onValuesChange={handleFormChange}
          >
            <Row gutter={12} className="g-3">
              <Col xs={24} sm={24} md={8} lg={8} xl={12}>
                <label className="mt-3">
                  Total Role: {filterRoleList?.length}
                </label>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={6} ref={containerRef}>
                <DropdownCheckBox
                  name="department"
                  label="Department"
                  options={uniqBy(
                    AllDepartmentList?.map((item) => {
                      return {
                        label: item?.department_name,
                        value: item?.department_id,
                      };
                    }),
                    "value"
                  )}
                  form={form}
                  handleFormChange={handleFormChange}
                />
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={6} ref={containerRef}>
                <DropdownCheckBox
                  name="location"
                  label="Location"
                  options={uniqBy(
                    locationList
                      ?.filter((item) => item?.login_from_anywhere !== 1)
                      .map((item) => {
                        return {
                          label: item?.location_name,
                          value: item?.location_id,
                        };
                      }),
                    "value"
                  )}
                  form={form}
                  handleFormChange={handleFormChange}
                />
              </Col>
            </Row>
          </Form>
          <Spin spinning={loading}>
            <StyledTable
              className="mt-0"
              dataSource={filterRoleList}
              // dataSource={roleList}
              columns={columns}
              rowKey="roleId"
              pagination={false}
              onRow={(record) => ({
                onClick: (e) => {
                  e.stopPropagation();
                  ViewRole(record);
                  setIsViewDetails(true);
                },
                className: "hover-row",
              })}
            />
          </Spin>
        </>
      )}
      {addRole && (
        <AddRole
          toggleAddRole={toggleAddRole}
          setRoleList={setRoleList}
          roleList={roleList}
          btnLoader={btnLoader}
          togglebtnLoader={togglebtnLoader}
          getRoleList={getRoleList}
        />
      )}
      {isEditRole && (
        <EditRole
          roleList={roleList}
          details={details}
          setIsEditRole={setIsEditRole}
          getRoleList={getRoleList}
        />
      )}
      {isViewDetails && (
        <RoleDetails details={details} setIsViewDetails={setIsViewDetails} />
      )}
      {isEditPermission && (
        <EditPermission
          details={details}
          setIsEditPermission={setIsEditPermission}
          getRoleList={getRoleList}
        />
      )}
      <StyledModal
        title={
          <div className="d-flex justify-content-between align-items-center">
            <div>{details?.roleName} - Permission</div>
            {Menulist?.find(
              (item) =>
                item?.key === "manage" &&
                item?.subMenu.find(
                  (subItem) =>
                    subItem?.key === "roles" && subItem?.permission.edit
                )
            ) && (
              <span
                style={{
                  marginRight: 20,
                  cursor: "pointer",
                  color: "#2D53DA",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsViewPermission(false);
                  setIsEditPermission(true);
                }}
              >
                <Edit
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsEditPermission(true)}
                />{" "}
                Edit
              </span>
            )}
          </div>
        }
        open={isViewPermission}
        onCancel={() => setIsViewPermission(false)}
        width={900}
        height={100}
        footer={false}
      >
        <div style={{ overflow: "hidden" }}>
          <RolesAndPermissions
            setMenuList={() => {}}
            menuList={details?.menuList}
            setsubmit={() => {}}
            loading={loading}
            type="view"
            viewOnly={true}
          />
        </div>
      </StyledModal>
    </RolesWrap>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveMenuList: setMenuList,
      updateUserList: setUserList,
      saveRoleList: setRoleList,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps, null)(RoleManagement);
